'use client';

import { c as _c } from "react/compiler-runtime";
import * as Headless from '@headlessui/react';
import { cn } from '@/frontend/utils';
export interface DropdownShortcutProps {
  keys: string | string[];
  className?: string;
}
export function DropdownShortcut(t0) {
  const $ = _c(14);
  let className;
  let keys;
  let props;
  if ($[0] !== t0) {
    ({
      keys,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = keys;
    $[3] = props;
  } else {
    className = $[1];
    keys = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn(className, "col-start-5 row-start-1 flex justify-self-end");
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== keys) {
    t2 = Array.isArray(keys) ? keys : [...keys];
    $[6] = keys;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t2) {
    t3 = t2.map(_temp);
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== props || $[11] !== t1 || $[12] !== t3) {
    t4 = <Headless.Description as="kbd" {...props} className={t1}>{t3}</Headless.Description>;
    $[10] = props;
    $[11] = t1;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
}
function _temp(char, index) {
  return <kbd key={index} className={cn(["min-w-[2ch] text-center font-sans text-zinc-400 capitalize group-data-focus:text-white forced-colors:group-data-focus:text-[HighlightText]", index > 0 && char.length > 1 && "pl-1"])}>{char}</kbd>;
}